import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListTreatmentAutoAssignJobsParams, TreatmentAutoAssignJob } from '../model/treatment-auto-assign-job';
import { PageModel } from '../model/page-model.model';

const basePath = '/api/treatment-auto-assign-jobs';

/** HTTP client for the designer auto-assignment audit trail. */
@Injectable({ providedIn: 'root' })
export class TreatmentAutoAssignJobClient {
    private readonly _httpClient = inject(HttpClient);

    list(params: ListTreatmentAutoAssignJobsParams): Observable<PageModel<TreatmentAutoAssignJob>> {
        let httpParams = new HttpParams();
        if (params.treatmentId != null && params.treatmentId.length > 0) {
            httpParams = httpParams.set('treatmentId', params.treatmentId);
        }
        if (params.status != null && params.status.length > 0) {
            httpParams = httpParams.set('status', params.status);
        }
        if (params.skipReason != null && params.skipReason.length > 0) {
            httpParams = httpParams.set('skipReason', params.skipReason);
        }
        if (params.from != null && params.from.length > 0) {
            httpParams = httpParams.set('from', params.from);
        }
        if (params.to != null && params.to.length > 0) {
            httpParams = httpParams.set('to', params.to);
        }
        httpParams = httpParams.set('page', String(params.page ?? 1));
        httpParams = httpParams.set('pageSize', String(params.pageSize ?? 50));
        return this._httpClient.get<PageModel<TreatmentAutoAssignJob>>(basePath, { params: httpParams });
    }

    getById(id: number): Observable<TreatmentAutoAssignJob> {
        return this._httpClient.get<TreatmentAutoAssignJob>(`${basePath}/${id}`);
    }

    /** Queues a fresh attempt for the job's treatment, e.g. after correcting the roster. */
    retry(id: number): Observable<TreatmentAutoAssignJob> {
        return this._httpClient.post<TreatmentAutoAssignJob>(`${basePath}/${id}/retry`, {});
    }

    /** Queues an attempt for a treatment directly. */
    trigger(treatmentId: string): Observable<TreatmentAutoAssignJob> {
        return this._httpClient.post<TreatmentAutoAssignJob>(`${basePath}/treatments/${treatmentId}`, {});
    }
}
